import Vue from "vue";
import authErrorMixin from "@/mixins/authErrorMixin";
import leftPanel from './components/LeftPanel.vue';
export default Vue.extend({
    mixins: [authErrorMixin],
    components: {
        leftPanel
    },
    props: {
        templateConfig: {}
    }
});
